import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Box,
  Grid,
  Button,
  Divider,
  Alert,
} from "@mui/material";
import { Form } from "formik";
import ScheduleForm from "../Forms/schedule";
import PaymentForm from "../Forms/paymentForm";
import InfoForm from "../Forms/infoForm";
import CheckoutSuccess from "./CheckoutSuccess";
import checkoutFormModel from "../FormModel/checkoutFormModel";
import "./styles.css";
import Question from "./question";
import { checkout, validatingPromoCode } from "../Services/Organisation.service";
import Addons from "./AddOn";
import { useTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';

interface State extends SnackbarOrigin {
  open: boolean;
  message: string
}
const { formId, formField } = checkoutFormModel;

function _renderStepContent(
  step: number,
  setActiveStep: any,
  values: any,
  setFieldValue: any,
  formValues: any,
  calendarObject: any,
  organisationid: string,
  activeStep: number,
  formRef: any,
  setNavigationDirection: any,
  navigationDirection: string,
  isLive: boolean
) {
  switch (step) {
    case 0:
      return <ScheduleForm formField={formField} setActiveStep={setActiveStep} values={values} setNavigationDirection={setNavigationDirection} navigationDirection={navigationDirection} />;
    case 1:
      return (
        <InfoForm
          formField={formField}
          values={values}
          setFieldValue={setFieldValue}
          formValues={formValues}
          calendarObject={calendarObject}
          organisationid={organisationid}
          setNavigationDirection={setNavigationDirection} navigationDirection={navigationDirection}

        />
      );
    case 2:
      return (
        <Addons organisationid={organisationid} calendarObject={calendarObject} ref={formRef}  setFieldValue={setFieldValue} setActiveStep={setActiveStep} activeStep={activeStep} setNavigationDirection={setNavigationDirection} navigationDirection={navigationDirection} />
      );
    case 3:
      return (
        <PaymentForm formField={formField} setFieldValue={setFieldValue} values={formValues} setActiveStep={setActiveStep} setNavigationDirection={setNavigationDirection} navigationDirection={navigationDirection}  isLive={isLive} />
      );
    default:
      return <div>Not Found</div>;
  }
}

interface CheckoutPageProps {
  calendarObject: any;
  setCount: (count: number) => void;
  formikProps: any;
  organisationid: string;
  closeModal: () => void
  isLive?:boolean
}

interface FormRef {
  submitForm: () => void;
  getFormData: () => any;
}

const CheckoutPage = React.memo(({
  calendarObject,
  setCount,
  formikProps,
  organisationid,
  closeModal,
  isLive=false
}: CheckoutPageProps) => {
  const [activeStep, setActiveStep] = useState(0);
  const [addonvalue, setAddonValue] = useState();
  const [navigationDirection, setNavigationDirection] = useState('forward');
  const { t } = useTranslation();
  const [checkInfoHaveValidValue, setCheckInfoHaveValidValue] = useState(false);
  const steps = [t("Schedule"), t("INFO"), t("ADDON"), t("CHECKOUT")];
  const isLastStep = activeStep === steps.length - 1;
  const formRef = useRef<FormRef | null>(null);
  const [state, setState] = React.useState<State>({
    open: false,
    vertical: 'bottom',
    horizontal: 'right',
    message: ''
  });
  const { vertical, horizontal, open, message } = state;
  const handleClick = (newState: any) => {
    setState( { ...newState, open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false});
  };
  const handleButtonClick = () => {
    // if (formRef.current) {
    //   const formData = formRef.current.getFormData();
    //   formikProps.setFieldValue("addons", formData.addons);
    //   setAddonValue(formData.addons);
    // }
  };

  const checkValidInfoPage = (className: any) => {
    const questionContainer = document.querySelector(`.${className}`);
    if (questionContainer) {
        const valueData: any[] = [];
        const inputItems = questionContainer.querySelectorAll("input");
        inputItems.forEach((item: HTMLInputElement) => {
            // Check if the input is a checkbox
            if (item.type === 'checkbox') {
                valueData.push(item.checked);  // Push true or false based on whether it is checked
            } else {
                valueData.push(item.value);  // For other inputs, push their 'value'
            }
        });

        const errorClassExist = questionContainer.querySelectorAll("div.Mui-error").length;        
        // Set state based on all values being truthy and no errors present
        setCheckInfoHaveValidValue(
            valueData.every(value => value) && errorClassExist === 0
        );
    } else {
      setCheckInfoHaveValidValue(true)
    }
};

const hasPositiveBookingType = useMemo(() => {
  return  formikProps?.values?.bookingMemberTypes &&
  Object.values<number>(formikProps?.values?.bookingMemberTypes as Record<string, number>).some(value => value > 0);
}, [formikProps.values])
    


  async function _handleSubmit(values: any, actions: any) {
    if (isLastStep && formikProps.isValid && !values.paymentDetails?.bookingId) {
      try {

        const bookingMemberTypes: any = {}
        Object.keys(values.bookingMemberTypes).forEach((key: string) => {
          if (values.bookingMemberTypes[key] > 0) {
            bookingMemberTypes[key] = values.bookingMemberTypes[key]
          }
        })
        values.bookingMemberTypes = bookingMemberTypes
        const response = await checkout({ ...values }, isLive);
        if (response) {
          formikProps.setFieldValue("stripePaymentDetails", response.stripSecssion)
          formikProps.setFieldValue("eurostripePaymentDetails", response.euroStripeSession)
        }
      } catch (error) {
        console.log(error, "error");
      }
    } else {
    }
  }


  useEffect(() => {
    _handleSubmit(formikProps.values, "");
  }, [isLastStep])

  useEffect(() => {
    setCount(activeStep);
    activeStep === 1 && checkValidInfoPage("questionContainer");
    activeStep === 2 && checkValidInfoPage("card");
  }, [activeStep, setCount]);

  useEffect(() => {
    setTimeout(() => {
      activeStep === 1 && checkValidInfoPage("questionContainer");
      activeStep === 2 && checkValidInfoPage("card");
    }, 500);
  }, [formikProps.values]);

  const validateBookingTicketsCount = () => {
    let noErrors = true;  // Flag to track error presence

    try {
      const dependsValueFeature = formikProps.values.dependsValueFeature;
      const bookingMemberTypesValues = formikProps.values.bookingMemberTypes;
      const totalTickets = Object.keys(bookingMemberTypesValues || {}).reduce((total, key) => {
        return total + (bookingMemberTypesValues[key] || 0);
      }, 0)
      if (dependsValueFeature) {
        Object.keys(dependsValueFeature).forEach((k) => {
          const obj = dependsValueFeature[k];
          if (!bookingMemberTypesValues[obj.parent] || bookingMemberTypesValues[obj.parent] < bookingMemberTypesValues[obj.children]) {
            const parentLabel = formikProps.values.bookingMemberTypesList?.find((typeObj: any) => typeObj.id === obj.parent)?.label;
            const childLabel = formikProps.values.bookingMemberTypesList?.find((typeObj: any) => typeObj.id === obj.children)?.label;
            handleClick({ vertical: 'bottom', horizontal: 'right', message: `Ticket Count Error: The number of tickets for '${parentLabel}' must be equal to or greater than the number of tickets for '${childLabel}'. Please adjust the ticket quantities to proceed.` })
            noErrors = false;
          }
        });
      }
      if(formikProps.values.selectedTimeSlotCapacity < totalTickets) {
        handleClick({ vertical: 'bottom', horizontal: 'right', message: `Ticket Count Error: You added more tickets than capacity. Capacity for selected day is only this ${formikProps.values.selectedTimeSlotCapacity} much. Please adjust the ticket quantities to proceed.` })
        noErrors = false;
      }
    } catch (error) {
      console.log("Error in validating ticket counts", error);
      noErrors = false;  // Assume false if an exception occurs
    }

    return noErrors;  // Return true if no errors, false otherwise
  }

  return (
    <React.Fragment>
      <React.Fragment>
        {activeStep === steps.length ? (
          <CheckoutSuccess />
        ) : (
          <Form id={formId} onSubmit={formikProps.handleSubmit}>
            <Grid
              className="heading"
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid xs={8}>
                <div className="title">
                  <KeyboardBackspaceIcon sx={{ cursor: "pointer", color: "#999999" }} onClick={() => {
                    setNavigationDirection("backward");
                    setActiveStep((step) => step - 1);
                    if(activeStep === 0) {
                      closeModal()
                    }
                  }} />
                  <span>
                    {activeStep !== 3 ? calendarObject?.calendarname : "Your Payment Information"}
                  </span>
                </div>
              </Grid>
              <CloseIcon sx={{ height: "16px", width: "16px", color: "#343434", cursor: "pointer", marginRight: "0.5rem" }} onClick={closeModal} />
            </Grid>
            <div className="tabcontainer">
              {_renderStepContent(
                activeStep,
                setActiveStep,
                calendarObject,
                formikProps.setFieldValue,
                formikProps.values,
                calendarObject,
                organisationid,
                activeStep,
                formRef,
                setNavigationDirection,
                navigationDirection,
                isLive
              )}
              {formikProps.values.firstName &&
                formikProps.values.lastName &&
                formikProps.values.phoneNumber &&
                formikProps.values.email &&
                !formikProps.errors.firstName &&
                !formikProps.errors.lastName &&
                !formikProps.errors.phoneNumber &&
                !formikProps.errors.email && (
                  <>
                    {activeStep === 1 && (
                      <Question
                        calendarObject={calendarObject}
                        values={formikProps.values}
                        setFieldValue={formikProps.setFieldValue}
                      />
                    )}
                  </>
                )}
            </div>
            { (
              <div className="buttons">
                <Divider sx={{ display: 'flex' }} />
                  {(activeStep !== 0 && activeStep !== 3) && (
                   <>
                      <Box className={`buttonContainer ${checkInfoHaveValidValue && hasPositiveBookingType && formikProps.values.firstName &&
                        formikProps.values.lastName &&
                        formikProps.values.phoneNumber &&
                        formikProps.values.email &&
                        !formikProps.errors.firstName &&
                        !formikProps.errors.lastName &&
                        !formikProps.errors.phoneNumber &&
                        !formikProps.errors.email ? "" : "disabled"}`}>
                        <Button
                          variant="contained"
                          type="submit"
                          className="continueButton"
                          onClick={(e) => {
                            e.preventDefault();
                            if (activeStep === 1) {
                              if (validateBookingTicketsCount()) {
                                formikProps.isValid && setActiveStep(2);
                              }
                            } else if (activeStep === 2) {
                              // handleButtonClick();
                              setActiveStep(3);
                            }
                            setNavigationDirection("forward")
                          }}
                        >
                          {t("Continue")}
                        </Button>
                      </Box>
                   </>
                  )}
                </div>
              )}
            
            <Snackbar
              anchorOrigin={{ vertical: vertical, horizontal: horizontal }}
              open={open}
              autoHideDuration={5000}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              <Alert
                onClose={handleClose}
                severity="error"
                variant="filled"
                sx={{ width: '40%' }}
              >
                {message}
              </Alert>
            </Snackbar>
          </Form>
        )}
      </React.Fragment>
    </React.Fragment>
  );
});

export default CheckoutPage